export const getFavoritePanels = () => {
    const favoritePanels = JSON.parse(localStorage.getItem("favoritePanels"));
    if (favoritePanels === null) {
        localStorage.setItem("favoritePanels", JSON.stringify([]));
        return [];
    }
    return favoritePanels;
};

export const addToFavoritePanels = id => {
    const favoritePanels = getFavoritePanels();
    if (!favoritePanels.includes(id)) {
        favoritePanels.push(id);
    }
    localStorage.setItem("favoritePanels", JSON.stringify(favoritePanels));
    return favoritePanels;
};

export const removeFromFavoritePanel = id => {
    let favoritePanels = getFavoritePanels();
    if (favoritePanels.includes(id)) {
        favoritePanels = favoritePanels.filter(panelId => panelId !== id);
        localStorage.setItem("favoritePanels", JSON.stringify(favoritePanels));
    }
    return favoritePanels;
};
